import { IDistricte } from 'bg-server/src/components/api/v1/districte/types';

import { ENV } from 'src/config/environments';
import { httpRequest } from 'src/helpers/http';
import { buildSearchRegex } from 'src/helpers/utils';
import { IDistricteSearchFilter } from 'src/interfaces';

class DistricteService {
    private getApiEndpoint(): string {
        const selectedCity = localStorage.getItem('selectedCity') || ENV.apiEndpoints[0].key;
        const apiEndpoint = ENV.apiEndpoints.find(endpoint => endpoint.key === selectedCity);
        return apiEndpoint ? `${apiEndpoint.url}` : `${ENV.apiEndpoints[0].url}`;
    }

    private transformSearchFilterDistricte(filter: IDistricteSearchFilter) {
        const searchField: any = {
            $and: [],
        };

        if (filter.searchString) {
            const regex = buildSearchRegex(filter.searchString);
            searchField.$and.push({
                nom: { $regex: regex, $options: 'i' },
            });
        }
        return searchField;
    }

    async getDistrictesByFilter(filter: IDistricteSearchFilter, page: number, pageSize = 20): Promise<{ count: number, data: IDistricte[] }> {
        const sFilter = this.transformSearchFilterDistricte(filter);
        const hasSearchFilter = (
            filter.searchString
        );

        const filterParams = hasSearchFilter
            ? `search=${encodeURIComponent(JSON.stringify(sFilter))}&`
            : '';

        const sortParams = filter.sortOrder ? `sort=${filter.sortOrder}&` : '';
        const pageParams = page ? `page=${page}&` : '';
        const pageSizeParams = pageSize ? `pageitems=${pageSize}` : '';

        const response = await httpRequest(`${this.getApiEndpoint()}/districte?${sortParams}${filterParams}${pageParams}${pageSizeParams}`, 'GET');
        const json = await response.json();
        if (json.error !== undefined) {
            await Promise.reject(json.message);
        }
        return json;
    }
}

export const districteService = new DistricteService();
